import { MQ_SMALL_ONLY, MQ_LARGE, MQ_MIDLARGE, MQ_MEDIUM } from 'constants/mq';
import IMAGE_SIZES from 'constants/imageSizes';

const { base4x5, medium4x5, large2x1 } = IMAGE_SIZES;

const base = {
  fallbackDims: base4x5,
  sourceSets: [
    {
      layoutWidth: { value: 574, units: 'px' },
      imageDims: large2x1,
      media: MQ_MIDLARGE
    },
    {
      layoutWidth: { value: 488, units: 'px' },
      imageDims: large2x1,
      media: MQ_LARGE
    },
    {
      layoutWidth: { value: 360, units: 'px' },
      imageDims: large2x1,
      media: MQ_MEDIUM
    },
    {
      layoutWidth: { value: 200, units: 'px' },
      imageDims: medium4x5,
      media: MQ_SMALL_ONLY
    }
  ],
  placeholders: [
    {
      media: MQ_MEDIUM,
      ratio: 2
    },
    {
      media: MQ_SMALL_ONLY,
      ratio: 4 / 5
    }
  ]
};

const exceptionPatterns = undefined;

export default {
  base,
  exceptionPatterns
};
